import React from 'react';
import PropTypes from 'prop-types';

import { SuiAvatar } from '@splashthat/sui';

const ALPHATAR_URLS = {
    a: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-A.jpg',
    b: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-B.jpg',
    c: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-C.jpg',
    d: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-D.jpg',
    e: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-E.jpg',
    f: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-F.jpg',
    g: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-G.jpg',
    h: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-H.jpg',
    i: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-I.jpg',
    j: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-J.jpg',
    k: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-K.jpg',
    l: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-L.jpg',
    m: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-M.jpg',
    n: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-N.jpg',
    o: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-O.jpg',
    p: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-P.jpg',
    q: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-Q.jpg',
    r: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-R.jpg',
    s: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-S.jpg',
    t: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-T.jpg',
    u: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-U.jpg',
    v: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-V.jpg',
    w: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-W.jpg',
    x: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-X.jpg',
    y: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-Y.jpg',
    z: 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-Z.jpg',
};

const UNKNOWN_ALPHATAR_URL = 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/alphatar-unknown.jpg'; // eslint-disable-line max-len

function getAlphatarUrl(name) {
    const splitName = name && name.trim().split(' ');

    if (splitName) {
        const firstLetter = splitName[0][0] || '';
        return ALPHATAR_URLS[firstLetter.toLowerCase()] || UNKNOWN_ALPHATAR_URL;
    }

    return UNKNOWN_ALPHATAR_URL;
}

const Alphatar = ({ icon, imageUrl, name, ...props }) => {
    if (name && !imageUrl && !icon) {
        return <SuiAvatar imageUrl={getAlphatarUrl(name)} name={name} {...props} />;
    }

    return <SuiAvatar imageUrl={imageUrl} icon={icon} name={name} {...props} />;
};

Alphatar.propTypes = {
    icon: PropTypes.element,
    imageUrl: PropTypes.string,
    name: PropTypes.string,
};

Alphatar.defaultProps = {
    icon: null,
    imageUrl: null,
    name: '',
};

export default Alphatar;
